export const CRYPTO_MODAL_WRAPPER_CLASS = "w-full max-w-none sm:max-w-[600px]";

/** Fixed desktop modal height: 90% viewport, capped at 700px. */
export const CRYPTO_MODAL_PANEL_HEIGHT_CLASS =
  "sm:h-[min(96dvh,810px)] sm:max-h-[850px] sm:min-h-0";

export const SCROLL_LIST_ROW_HEIGHT_PX = 100;
export const SCROLL_LIST_ROW_GAP_PX = 8;
export const SCROLL_LIST_VISIBLE_ROWS = 4;

export const getScrollListMaxHeight = (
  rowHeight = SCROLL_LIST_ROW_HEIGHT_PX,
  visibleRows = SCROLL_LIST_VISIBLE_ROWS,
  gap = SCROLL_LIST_ROW_GAP_PX,
) => visibleRows * rowHeight + (visibleRows - 1) * gap;

export const SCROLL_LIST_MAX_HEIGHT_PX = getScrollListMaxHeight();
